<template>
  <div>
    <div
      class="pending-appointments"
      v-if="changedAppointments && !noPendingAppsRoutes.includes($route.name)"
    >
      נמצאו {{ changedAppointments }} תורים שמועדם השתנה.
      <router-link :to="{ name: 'pending-appointments' }">
        לצפייה ושליחת sms
      </router-link>
    </div>
    <section class="calc-headwrap">
      <div class="calendar-heading flex">
        <div class="flex flex--center w-100 flex--between">
          <a
            class="flex flex--center text-sm"
            href="javascript:void(0)"
            @click.prevent="goBack"
          >
            <img
              class="arrow_back_r ml-2"
              src="/assets/img/svg/arrow_back_r.svg"
              alt="icon"
            />
            {{
              $route.name == "Dashboard"
                ? "חזור"
                : $moment(currentDate).format("MMMM YYYY")
            }}
          </a>

          <div
            class="flex flex--center text-sm"
            v-show="$route.name == 'Dashboard'"
            @click="canMoveBetweenDatesOrTabs(false)"
            v-intro="'מעבר מהיר לצפייה ביום מרפאה קודם או עתידי.'"
          >
            <img class="ml-2" src="/assets/img/svg/ic-date.svg" alt="icon" />
            שינוי תאריך
          </div>

          <a
            v-if="$route.name === 'surgeries-list' || $route.name === 'list'"
            class="clear-filters flex"
            href="javascript:void(0)"
            @click="exportToExcel"
          >
            <img src="/assets/img/svg/download.svg" alt="" />ייצוא לקובץ
          </a>
        </div>
      </div>

      <!-- tabs -->
      <div class="tabs-sch flex flex--center" v-if="$route.name == 'Dashboard'">
        <a
          class="tabs-sch-item flex flex--center"
          :class="{ active: showAppointment && !isMobileDragDrop }"
          href="javascript:void(0);"
          @click="changeTab('appointment')"
        >
          <img class="reg" src="/assets/img/svg/tab-list.svg" alt="icon" />
          <img class="hov" src="/assets/img/svg/tab-list-hov.svg" alt="icon" />
          תצוגת יומן
        </a>
        <a
          class="tabs-sch-item flex flex--center"
          href="javascript:void(0);"
          :class="{
            disabled: isSelectedDatePassedMobiscroll,
            active: isMobileDragDrop
          }"
          @click="changeTab('mobiscroll')"
          v-intro="'חדש! עריכת מהירה ישירות מהיומן.'"
          v-intro-step="2"
        >
          <img class="reg" src="/assets/img/svg/tab-edit.svg" alt="icon" />
          <img class="hov" src="/assets/img/svg/tab-edit-hov.svg" alt="icon" />
          עריכת יומן
        </a>
        <a
          class="tabs-sch-item flex flex--center"
          :class="{
            active: !showAppointment && !isMobileDragDrop,
            disabled: isSelectedDateTodayOrBefore
          }"
          href="javascript:void(0);"
          @click="changeTab('block')"
          v-intro="
            'עדכון עצמאי של שעות הבלוק, מחיקתו או חסימתו לשיבוצים חיצוניים.'
          "
          v-intro-step="3"
        >
          <img class="reg" src="/assets/img/svg/tab-block.svg" alt="icon" />
          <img class="hov" src="/assets/img/svg/tab-block-hov.svg" alt="icon" />
          עריכת בלוק
        </a>
      </div>
      <!-- /tabs -->

      <div class="non-scheduled" v-if="$route.name == 'surgeries'">
        <h2>ניתוחים לשיבוץ</h2>
        <div class="head_search relative none_scheduled_container">
          <input
            class="head_search_input none_scheduled_search_input"
            type="text"
            placeholder="סנן לפי ת.ז"
            v-model="query"
            v-on:keypress="numbersOnly"
            autocomplete="off"
          />
          <input class="head_search_submit" type="submit" value="" />
        </div>
        <ul class="text-center non-scheduled-list">
          <li
            v-for="surg in none_scheduled_limit"
            :key="surg.surgery_order_id"
            @click="scheduleSurgery(surg.surgery_order_id)"
          >
            {{
              surg.patient_name +
                " " +
                surg.passport +
                " | " +
                surg.insurance_name +
                " " +
                surg.phone +
                " | משך זמן הניתוח: " +
                surg.surgery_duration
            }}
          </li>
          <a
            v-if="
              filteredNoneScheduledEvents &&
                filteredNoneScheduledEvents.length > 2
            "
            class="show_more_bt"
            @click.prevent="show_all_non_scheduled = !show_all_non_scheduled"
          >
            {{ show_all_non_scheduled ? "הצג פחות" : "הצג עוד" }}
          </a>
          <div
            v-if="!none_scheduled_limit || !none_scheduled_limit.length"
            class="center"
          >
            <img
              style="margin-bottom:8px"
              src="/assets/img/svg/circ-close.svg"
            />
            <h2 class="mb--22 title--32">
              אין ניתוחים<br />
              הממתינים לשיבוץ
            </h2>
          </div>
        </ul>
      </div>

      <div class="dates-slider flex" v-if="$route.name != 'Dashboard'">
        <span
          class="dates-slider__item"
          v-for="date in dates"
          :key="date"
          @click="changeDate(date)"
          :class="{
            active: compareSameDate(currentDate, date)
          }"
        >
          <div class="dates-slider__item--day">
            {{ $moment(date, "DD/MM/YYYY").format("dd") }}
          </div>
          <div class="dates-slider__item--date">
            {{ $moment(date, "DD/MM/YYYY").format("D") }}
          </div>
        </span>
      </div>
      <!-- <div class="current-date">
        <div class="flex current-date__inner">
          <div>{{ $moment(currentDate).format("יום dddd DD/MM/YYYY") }}</div>
          <div v-if="$route.name != 'list'" class="availble-appointments">
          {{ availbleAppointments }} תורים פנויים
        </div>
        </div>
      </div> -->
      <div
        class="select-room bg--white"
        v-if="$route.name == 'surgeries' || $route.name == 'calendar'"
      >
        <div class="flex flex--content--center">
          <select2 v-model="selected_room">
            <option value="">בחר חדר</option>
            <option
              v-for="room in filteredDoctorRooms"
              :key="room"
              :value="room"
            >
              {{ allRooms[room].name }}
            </option>
          </select2>
        </div>
      </div>
    </section>
    <!--/head-->
  </div>
</template>

<script>
//import ArrowBack from "../../assets/img/svg/arrow_back.svg";
import ScheduleSurgery from "@/components/Popups/ScheduleSurgery";
import { mapGetters, mapMutations, mapState } from "vuex";
import Error from "@/components/Popups/Error";
import UnsavedChangesAlert from "@/components/Popups/UnsavedChangesAlert";
import { numbersOnly } from "../../utilities/globals";
import {
  exportSurgeriesToExcel,
  exportAppointmentsToExcel
} from "../../utilities/export-to-excel";
import { compareDate } from "../../utilities/dates.js";

export default {
  name: "DaysSlider",
  props: [
    "currentDate",
    "blocks",
    "isRoom",
    "showAppointment",
    "onlyEvents",
    "canStartTutorial"
  ],
  mounted() {
    this.getPendingAppAndEv();
    if (this.activeDoctor) {
      this.$API.getRoomsByDoctor(this.activeDoctor.id).then(res => {
        this.SET_DOCTOR_ROOMS(res.data.data);
      });
    }

    // Tutorial
    if (this.canStartTutorial) this.startTutorial();

    if (this.appointmentInitialTab == "block") {
      this.$emit("toggleShowAppointment", false);
      this.TOGGLE_MOBISCROLL(false);
    }
    this.SET_INITIAL_TAB("");
    // listen to reschedule surgery
    this.$root.$on("rescheduleSurgery", () => {
      const isMobile = window.innerWidth < 1200;
      if (!isMobile) return;
      this.getPendingAppAndEv();
    });
  },
  data() {
    return {
      non_scheduled: [],
      pending_appointments: [],
      selected_room: "",
      show_all_non_scheduled: false,
      doctors_rooms: [],
      noPendingAppsRoutes: [
        "surgeries",
        "surgeries-list",
        "list",
        "surg-app-list"
      ],
      query: "",
      isShowMore: false
    };
  },
  watch: {
    selected_room(value) {
      this.$emit("selected_room", { room: value });
    },
    isRoom() {
      if (!this.isRoom) this.selected_room = "";
    },
    activeDoctor(value, prevValue) {
      if (this.activeDoctor && (value != prevValue || !this.doctorRooms)) {
        this.$API.getRoomsByDoctor(this.activeDoctor.id).then(res => {
          this.SET_DOCTOR_ROOMS(res.data.data);
        });
      }
      this.getPendingAppAndEv();
    },
    canStartTutorial(val) {
      if (val) this.startTutorial();
    }
  },
  computed: {
    ...mapState(["doctorRooms"]),
    ...mapGetters([
      "activeUser",
      "activeDoctor",
      "allRooms",
      "isMobileDragDrop",
      "isSelectedDatePassedMobiscroll",
      "isSelectedDateTodayOrBefore",
      "appointmentInitialTab",
      "eventsToSave"
    ]),
    filteredNoneScheduledEvents() {
      if (!this.non_scheduled || !this.non_scheduled.length) return [];
      if (!this.query) {
        return [...this.non_scheduled];
      } else {
        return this.non_scheduled.filter(ev =>
          ev.passport.includes(this.query)
        );
      }
    },
    none_scheduled_limit() {
      if (this.show_all_non_scheduled) return this.filteredNoneScheduledEvents;
      if (this.filteredNoneScheduledEvents.length)
        return this.filteredNoneScheduledEvents.slice(0, 2);
      return [];
    },
    filteredDoctorRooms() {
      if (!this.blocks || !this.blocks.length) return [];
      let rooms = [];
      this.blocks.forEach(ev => {
        const evStart = this.$moment(ev.start).format("YYYY-MM-DD");
        const select = this.$moment(this.currentDate).format("YYYY-MM-DD");
        let find;
        if (evStart == select) {
          if (rooms && rooms.length && ev.resourceId) {
            find = rooms.find(room => room == ev.resourceId);
          }
          if (!find && this.allRooms[ev.resourceId]) {
            rooms.push(ev.resourceId);
          }
        }
      });
      this.selectRoom(rooms);
      return rooms;
    },
    changedAppointments() {
      return this.pending_appointments.length;
    },
    availbleAppointments() {
      let today = this.$moment(this.currentDate);
      let appointments = 0;
      let timeInMinutes = 0;
      for (const todayElement of this.blocks) {
        let start = this.$moment(new Date(todayElement.start));
        let end = this.$moment(new Date(todayElement.end));

        if (
          start.isSame(today, "day") &&
          typeof todayElement.appointment_id == "undefined"
        ) {
          timeInMinutes = end.diff(start, "m");
          appointments += Math.floor(timeInMinutes / 30);
        }
      }
      if (appointments > 0) {
        for (const todayElement of this.blocks) {
          let start = this.$moment(new Date(todayElement.start));
          let end = this.$moment(new Date(todayElement.end));
          if (
            start.isSame(today, "day") &&
            typeof todayElement.appointment_id != "undefined"
          ) {
            appointments--;
          }
        }
      }

      return Math.abs(appointments);
    },
    dates() {
      let datesArr = [];
      let dates = this.blocks.slice().sort((a, b) => a.start - b.start);
      // let currentTime = this.$moment(this.currentDate);
      for (const i in dates) {
        let date = this.$moment(new Date(dates[i].start)).format("DD/MM/YYYY");
        if (!datesArr.includes(date)) {
          datesArr.push(date);
        }
      }
      let week = [];
      var index_of_current_day = "";
      for (var key in datesArr) {
        // let diffInDays = currentTime.diff(
        //   this.$moment(datesArr[key], "DD/MM/YYYY"),
        //   "days"
        // );
        // let now = currentTime.toArray();
        // var cmp = this.$moment(datesArr[key], "DD/MM/YYYY").toArray();
        let index = key - 1;
        // let array_length = datesArr.length;
        let days = index + 7;

        for (index; index < days; index++) {
          if (typeof datesArr[index] != "undefined") {
            if (typeof week.find(d => d == datesArr[index]) == "undefined") {
              week.push(datesArr[index]);
            }
          }
        }
      }
      index_of_current_day = week.indexOf(
        this.$moment(this.currentDate).format("DD/MM/YYYY")
      );
      var week_filtered = [];

      if (index_of_current_day < 0) {
        let current_date = this.$moment(this.currentDate).format("DD/MM/YYYY");
        let current_date_arr = current_date.split("/");
        let last_day = 1;
        for (const index in week) {
          let arr = week[index].split("/");
          // let prev_day = 0;
          let index_day = index;
          if (index > 0) {
            index_day = index - 1;
          }
          last_day = week[index_day].split("/")[0];
          if (
            current_date_arr[1] == arr[1] &&
            current_date_arr[0] > last_day &&
            current_date_arr[0] < arr[0]
          ) {
            week.splice(index, 0, current_date);
          }
        }
      }
      index_of_current_day = week.indexOf(
        this.$moment(this.currentDate).format("DD/MM/YYYY")
      );
      for (const index in week) {
        let limit_before = index_of_current_day - 3;
        let limit_after = index_of_current_day + 3;

        if (index >= limit_before && index <= limit_after) {
          week_filtered.push(week[index]);
        }
      }
      return week_filtered;
    }
  },
  methods: {
    ...mapMutations([
      "SET_DOCTOR_ROOMS",
      "TOGGLE_MOBISCROLL",
      "SET_INITIAL_TAB",
      "UPDATE_EVENTS_TO_SAVE",
      "TOGGLE_CALENDAR_POPUP"
    ]),
    numbersOnly,
    goBack() {
      this.TOGGLE_MOBISCROLL(false);
      this.$emit("toggleShowAppointment", true);
      this.$emit("go-back", this);
    },
    changeDate(date) {
      this.$emit("change-date", { date: date });
    },
    removeSurgFromNonScheduled(id) {
      if (!id) return;

      let index = this.non_scheduled.findIndex(s => s.surgery_order_id == id);
      if (index === -1) return;

      this.non_scheduled.splice(index, 1);
    },
    scheduleSurgery(event) {
      let find = this.non_scheduled.find(s => s.surgery_order_id == event);
      if (!find) return;
      this.$API
        .getScheduleTableForSurgery(find.doctor_id, find.surgery_order_id)
        .then(res => {
          this.$modal.show(
            ScheduleSurgery,
            {
              data: res.data,
              surgery: find,
              onCLoseFunc: this.removeSurgFromNonScheduled
            },
            {
              classes: "show_overflow"
            }
          );
        });
    },
    compareSameDate(date1, date2) {
      const d = this.$moment(date1).format("DD/MM/YYYY");
      if (d === date2) return true;
      return false;
    },
    getPendingAppAndEv() {
      if (!this.activeDoctor || !this.activeDoctor.id) return;
      this.$API
        .getNonScheduleEvents(
          "surgery_gastro_catheterization",
          this.activeDoctor.id
        )
        .then(res => {
          this.non_scheduled = res;
        });
      this.$API
        .getPendingAppointments(this.activeDoctor.id)
        .then(res => {
          this.pending_appointments = res.message;
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    },
    selectRoom(rooms) {
      if (rooms && rooms.length == 1) {
        setTimeout(() => {
          this.selected_room = rooms[0];
        }, 50);
      }
    },
    changeTab(tab, forceChange = false) {
      const res = this.canMoveBetweenDatesOrTabs(true, tab);
      if (!res && !forceChange) return;
      switch (tab) {
        case "appointment":
        case "block":
          if (tab == "block" && this.isSelectedDateTodayOrBefore) break;
          this.$emit("toggleShowAppointment", tab == "appointment");
          this.TOGGLE_MOBISCROLL(false);
          if (tab === "block") this.blockEditTutorial();
          break;
        case "mobiscroll":
          if (!this.isSelectedDatePassedMobiscroll) {
            this.TOGGLE_MOBISCROLL(true);
            this.$emit("setMobiscrollEvents");
            this.mobiscrollTutorial();
          }
        default:
          break;
      }
    },
    canMoveBetweenDatesOrTabs(isTab, value) {
      if (this.$route.name != "Dashboard") return true;
      if (!this.eventsToSave || !this.eventsToSave.length) {
        if (!isTab) this.TOGGLE_CALENDAR_POPUP(true);
        return true;
      }
      this.$modal.show(UnsavedChangesAlert, {
        confirmFunc: ev => {
          if (ev) {
            this.UPDATE_EVENTS_TO_SAVE([]);
            if (isTab) this.changeTab(value, true);
            else this.TOGGLE_CALENDAR_POPUP(true);
          }
        }
      });
      return false;
    },
    exportToExcel() {
      const filteredEvs = this.onlyEvents.filter(ev =>
        compareDate(ev.start, this.currentDate)
      );
      if (this.$route.name === "list") {
        exportAppointmentsToExcel(filteredEvs);
      } else {
        exportSurgeriesToExcel(filteredEvs);
      }
    },
    async startTutorial() {
      await new Promise(resolve => setTimeout(resolve, 1200));
      const dragIntro = localStorage.getItem("mobile-drag-intro");
      if (dragIntro) return;

      const introJs = this.$intro();
      introJs.setOptions({
        doneLabel: "הבנתי, סיים",
        nextLabel: "הבא",
        prevLabel: "הקודם",
        skipLabel: "דלג"
      });

      introJs.oncomplete(() => {
        localStorage.setItem("mobile-drag-intro", true);
      });
      introJs.start();
    },
    async mobiscrollTutorial() {
      await new Promise(resolve => setTimeout(resolve, 900));
      const dragIntro = localStorage.getItem("mobiscroll-intro");
      if (dragIntro) return;

      const introJs = this.$intro();
      const events = document.querySelectorAll(".mbsc-schedule-event");
      let stepElementOne = events?.length
        ? events[0]
        : document.querySelector(".mbsc-schedule-color-text");
      let stepElementTwo = document.querySelector(".mbsc-schedule-color-text");

      if (!stepElementOne || !stepElementTwo) return;

      introJs.setOptions({
        doneLabel: "הבנתי, סיים",
        nextLabel: "הבא",
        prevLabel: "הקודם",
        skipLabel: "דלג",
        steps: [
          {
            element: stepElementOne,
            intro: `לחץ לחיצה ארוכה על התור אותו תרצה לערוך. התור יסומן בכתום ויאפשר גרירה לשעה אחרת, צמצום או הגדלת משך התור.
בסיום, יש ללחוץ על כפתור 'שמירה' בתחתית המסך.
לתשומת ליבך: לא ניתן לבצע שינוי בתור שעבר זמנו.`
          },
          {
            element: stepElementTwo,
            intro: `ניתן לייצר תור חדש על ידי לחיצה מהירה במקום פנוי ביומן.
לתשומת ליבך: לאחר הלחיצה יוצג ריבוע צהוב של תור חדש, יש ללחוץ עליו שוב בכדי לעדכן את פרטי התור ולשמור את פרטיו.
ללא עדכון פרטי התור, לא ישמר תור חדש.`
          }
        ]
      });

      introJs.oncomplete(() => {
        localStorage.setItem("mobiscroll-intro", true);
      });
      introJs.start();
    },
    async blockEditTutorial() {
      await new Promise(resolve => setTimeout(resolve, 900));
      const dragIntro = localStorage.getItem("edit-block-intro");
      if (dragIntro) return;

      const introJs = this.$intro();
      let stepElement = document.querySelector(".block-edit-btn") || null;
      if (!stepElement) return;

      introJs.setOptions({
        doneLabel: "הבנתי, סיים",
        steps: [
          {
            element: stepElement,
            intro: `לחיצה על הכפתור 'עריכה' תציג את תפריט הפעולות לבחירתך.`
          }
        ]
      });

      introJs.oncomplete(() => {
        localStorage.setItem("edit-block-intro", true);
      });
      introJs.start();
    }
  },
  components: {
    //ArrowBack
  }
};
</script>

<style scoped>
.dates-slider {
  padding: 0 15px;
}
.dates-slider__item {
  text-align: center;
}
.dates-slider__item.active .dates-slider__item--date {
  color: #fff;
  background-color: #324997;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.availble-appointments {
  background: rgba(50, 73, 151, 0.5);
  padding: 0 5px;
  line-height: 30px;
}
.current-date__inner div {
  margin: 0 10px;
}
.current-date__inner {
  justify-content: center;
}
.current-date {
  border-top: 1px solid rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  margin-top: 10px;
  padding: 10px 0;
}
.header_vuecal .vuecal__weekdays-headings {
  display: none !important;
}
.calendar-heading {
  color: #324997;
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;
  padding: 15px;
}
.calendar-heading .goback {
  margin-left: 20px;
  transform: scale(-1);
}
.pending-appointments {
  padding: 0 15px;
  color: red;
}
.non-scheduled {
  background-color: #5582bd;
}
.non-scheduled h2 {
  text-align: center;
  color: #fff;
}
.non-scheduled-list {
  display: block;
  padding: 0 20px;
  overflow: auto;
}
.non-scheduled-list li {
  display: block;
  padding: 10px;
  background-color: #fff;
  margin-bottom: 10px;
}

.select-room {
  padding: 25px 50px;
}
.select-room .select2-container--default .select2-selection--single,
.select-room .select2-selection.select2-selection--single {
  background: #eeeeee !important;
}
.show_more_bt {
  text-align: center;
  display: block;
  font-weight: 600;
  text-decoration: underline;
  color: #fff;
  padding-bottom: 20px;
}
.pending-appointments a {
  font-weight: bold;
  text-decoration: underline;
  color: #b90123;
}
.pending-appointments {
  background-color: #edd1cd;
  color: #b90123;
  font-size: 21px;
  padding: 10px;
  text-align: center;
}
</style>
